import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.instarizz.me';

// Configuration of axios instance for analysis requests
const analysisApi = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

/**
 * Delete an analysis from user history
 * @param {string} analysisId - The ID of the analysis to delete
 * @returns {Promise} - Promise that resolves when the analysis has been deleted
 */
export const deleteAnalysis = async (analysisId) => {
  try {
    // Get JWT token from authenticated user
    const token = localStorage.getItem('token');
    
    if (!token) {
      throw new Error('No authentication token found');
    }
    
    // Make DELETE request to the API
    const response = await analysisApi.delete(`/api/analysis/${analysisId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    
    console.log('Analysis deleted successfully:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error deleting analysis:', error);
    throw error;
  }
};

/**
 * Clean up invalid analyses from user history
 * @returns {Promise} - Promise that resolves with cleanup results
 */
export const cleanupInvalidAnalyses = async () => {
  try {
    // Get JWT token from authenticated user
    const token = localStorage.getItem('token');
    
    if (!token) {
      throw new Error('No authentication token found');
    }
    
    // Make POST request to the cleanup API
    const response = await analysisApi.post('/api/analysis/cleanup', null, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    
    console.log('Cleanup completed successfully:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error cleaning up analyses:', error);
    throw error;
  }
};

export default {
  deleteAnalysis,
  cleanupInvalidAnalyses
}; 